"use strict";
exports.__esModule = true;
exports.gasMultiplier = void 0;
var tslib_1 = require("tslib");
var config_1 = require("../../common/config");
var transaction_speed_1 = tslib_1.__importDefault(require("../types/transaction-speed"));
function gasMultiplier(speed) {
    switch (speed) {
        case transaction_speed_1["default"].Slow: return config_1.Config.SLOW_GAS_PRICE_MULTIPLIER;
        case transaction_speed_1["default"].Average: return config_1.Config.AVERAGE_GAS_PRICE_MULTIPLIER;
        case transaction_speed_1["default"].Fast: return config_1.Config.FAST_GAS_PRICE_MULTIPLIER;
    }
}
exports.gasMultiplier = gasMultiplier;
exports["default"] = gasMultiplier;
